import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../api";
import "./registration.css";

import { useTheme } from "../../components/header/header";
import Input from "../../components/input/input";
import Button from "../../components/button/button";

import logo from "./img/logo.svg";
import logoDark from "./img/logo-dark.svg";
import image1 from "./img/img.png";

const Registration = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { theme } = useTheme();

  const navigate = useNavigate();

  const validateEmail = (val) => {
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$/;
    if (!emailPattern.test(email)) {
      return "Please enter a valid email address.";
    }
    return null;
  };

  const validatePassword = (val) => {
    if (val.length < 6) {
      return "Password must be at least 6 characters long.";
    }
    return null;
  };

  const validateConfirmPassword = (val, password) => {
    if (val !== password) {
      return "Passwords do not match.";
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;

    if (validateEmail(email)) {
      isValid = false;
    }
    if (validatePassword(password)) {
      isValid = false;
    }
    if (validateConfirmPassword(confirmPassword, password)) {
      isValid = false;
    }

    if (!isValid) {
      setError("Something went wrong");
      return;
    }

    setLoading(true);

    try {
      const response = await api.post("/api/register", {
        email,
        password,
      });
      console.log(response.data);
      navigate("/");
    } catch (err) {
      if (err.response) {
        setError(err.response.data.error.message);
      } else {
        setError("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const isButtonDisabled = !email || !password || !confirmPassword || loading;

  return (
    <div className="container">
      <div>
        <div className="logoWrap">
          <img src={theme === "light" ? logo : logoDark} alt="logo" />
        </div>
        <div className="imgWrap">
          <img className="img" src={image1} alt="img" />
        </div>
        <h1 className="title">Registration</h1>
        <form>
          {/* <Input
            label="Email address"
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <Input
            label="Password"
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Input
            label="Confirm password"
            id="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          /> */}
          <Input
            label="Email address"
            id="email"
            type="email"
            value={email}
            onChange={(val) => setEmail(val)}
            validate={(val) => validateEmail(val)}
          />
          <Input
            label="Password"
            id="password"
            type="password"
            value={password}
            onChange={(val) => setPassword(val)}
            validate={(val) => validatePassword(val)}
          />
          <Input
            label="Confirm password"
            id="confirmPassword"
            type="password"
            value={confirmPassword}
            onChange={(val) => setConfirmPassword(val)}
            validate={(val) => validateConfirmPassword(val, password)}
          />
          <Button
            text="Register"
            onClick={handleSubmit}
            disabled={isButtonDisabled}
            loading={loading}
          />
          {error && <div className="error">{error}</div>}
        </form>
        <div className="bottomText">
          Already have an account?{" "}
          <Link className="bottomTextLink" to="/">
            Log In
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Registration;
